import { NextPage } from "next";
import MarketsOverview from "@/components/markets-pulse/MarketsPulse";
import styles from "./index.module.scss";
import PageSeo from "@/components/page-seo/PageSeo";

const MarketsOverviewPage: NextPage = (props) => {
    return (
        <>
            <PageSeo
                title="Stock Market Overview Today | ORTEX"
                pageName="Markets Overview"
                canonicalPath="/markets-overview"
                description="Today's stock market at a glance: index moves, the biggest ORTEX signals, short interest risers, insider buying, US government trades and options flow."
                keywords="Stocks, Financial analytics, financial data, stock screening, short interest, short squeeze, options, options flow, gamma squeeze, fundamentals, stocks, NYSE, Nasdaq, equity, trading, trading ideas, trading signals, dividend"
            />

            <div className={styles.MarketsOverviewPage}>
                <MarketsOverview />
            </div>
        </>
    );
};

export default MarketsOverviewPage;
